__webpack_require__.p = "/zip-practice/";